import { useCallback, useLayoutEffect, useRef, useState } from "react";

export function useFocusSignal<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [tick, setTick] = useState(0);

  // Runs right after DOM updates, before paint
  useLayoutEffect(() => {
    if (!tick) return;
    const el = ref.current;
    if (!el) return;
    // Defer to next frame so newly mounted nodes are focusable
    console.log(el.focus);
    el.focus();
    // Auto-select text if it's an input/textarea
    //   if ("select" in (el as any)) (el as HTMLInputElement | HTMLTextAreaElement).select?.();
  }, [tick]);

  const trigger = useCallback(() => setTick((n) => n + 1), []);

  // Optional direct focus if you already know the element is mounted
  const focusNow = useCallback(() => ref.current?.focus(), []);

  return { ref, trigger, focusNow };
}
